var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _line, _line2, _circle, _circle2, _rect, _mask, _rect2, _mask2, _rect3, _mask3, _rect4, _mask4, _rect5, _mask5, _rect6, _rect7, _rect8, _rect9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 331,
    height: 233,
    viewBox: "0 0 331 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.8193 219.94C80.8193 219.388 81.2671 218.94 81.8193 218.94H248.819C249.372 218.94 249.819 219.388 249.819 219.94V229.94C249.819 230.493 249.372 230.94 248.819 230.94H81.8193C81.267 230.94 80.8193 230.493 80.8193 229.94V219.94Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8193 220.94H248.819V216.94H81.8193V220.94ZM247.819 219.94V229.94H251.819V219.94H247.819ZM248.819 228.94H81.8193V232.94H248.819V228.94ZM82.8193 229.94V219.94H78.8193V229.94H82.8193ZM81.8193 228.94C82.3716 228.94 82.8193 229.388 82.8193 229.94H78.8193C78.8193 231.597 80.1625 232.94 81.8193 232.94V228.94ZM247.819 229.94C247.819 229.388 248.267 228.94 248.819 228.94V232.94C250.476 232.94 251.819 231.597 251.819 229.94H247.819ZM248.819 220.94C248.267 220.94 247.819 220.493 247.819 219.94H251.819C251.819 218.284 250.476 216.94 248.819 216.94V220.94ZM81.8193 216.94C80.1625 216.94 78.8193 218.284 78.8193 219.94H82.8193C82.8193 220.493 82.3716 220.94 81.8193 220.94V216.94Z",
    fill: "#686868"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8193 215.94C74.8193 215.388 75.2671 214.94 75.8193 214.94H254.819C255.372 214.94 255.819 215.388 255.819 215.94V221.94C255.819 222.493 255.372 222.94 254.819 222.94H75.8193C75.2671 222.94 74.8193 222.493 74.8193 221.94V215.94Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8193 216.94H254.819V212.94H75.8193V216.94ZM253.819 215.94V221.94H257.819V215.94H253.819ZM254.819 220.94H75.8193V224.94H254.819V220.94ZM76.8193 221.94V215.94H72.8193V221.94H76.8193ZM75.8193 220.94C76.3716 220.94 76.8193 221.388 76.8193 221.94H72.8193C72.8193 223.597 74.1625 224.94 75.8193 224.94V220.94ZM253.819 221.94C253.819 221.388 254.267 220.94 254.819 220.94V224.94C256.476 224.94 257.819 223.597 257.819 221.94H253.819ZM254.819 216.94C254.267 216.94 253.819 216.493 253.819 215.94H257.819C257.819 214.284 256.476 212.94 254.819 212.94V216.94ZM75.8193 212.94C74.1625 212.94 72.8193 214.284 72.8193 215.94H76.8193C76.8193 216.493 76.3716 216.94 75.8193 216.94V212.94Z",
    fill: "#686868"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6799 215.351C31.8481 210.833 17.4298 197.329 22.3989 181.486C23.5187 177.916 25.8393 174.619 29.3093 173.219C34.4136 171.159 40.7035 172.042 43.4245 176.247C45.8975 180.069 44.0096 185.3 40.5401 188.247C35.9037 192.186 27.5972 195.199 14.68 191.351C-21.6747 180.522 26.6801 141.848 65.1804 161.351",
    stroke: "#959595",
    strokeWidth: 3,
    strokeDasharray: "7 8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M291.32 72.94C299.152 77.4583 313.57 90.962 308.601 106.805C307.481 110.375 305.161 113.672 301.691 115.072C296.586 117.132 290.297 116.249 287.576 112.044C285.102 108.222 286.99 102.991 290.46 100.044C295.096 96.1052 303.403 93.0919 316.32 96.9395C352.675 107.769 304.32 146.443 265.82 126.94",
    stroke: "#959595",
    strokeWidth: 3,
    strokeDasharray: "7 8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8193 41.9404C63.8193 40.2836 65.1625 38.9404 66.8193 38.9404H263.819C265.476 38.9404 266.819 40.2836 266.819 41.9404V213.94C266.819 215.597 265.476 216.94 263.819 216.94H66.8193C65.1625 216.94 63.8193 215.597 63.8193 213.94V41.9404Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8193 40.4404H263.819V37.4404H66.8193V40.4404ZM265.319 41.9404V213.94H268.319V41.9404H265.319ZM263.819 215.44H66.8193V218.44H263.819V215.44ZM65.3193 213.94V41.9404H62.3193V213.94H65.3193ZM66.8193 215.44C65.9909 215.44 65.3193 214.769 65.3193 213.94H62.3193C62.3193 216.426 64.3341 218.44 66.8193 218.44V215.44ZM265.319 213.94C265.319 214.769 264.648 215.44 263.819 215.44V218.44C266.305 218.44 268.319 216.426 268.319 213.94H265.319ZM263.819 40.4404C264.648 40.4404 265.319 41.112 265.319 41.9404H268.319C268.319 39.4551 266.305 37.4404 263.819 37.4404V40.4404ZM66.8193 37.4404C64.3341 37.4404 62.3193 39.4551 62.3193 41.9404H65.3193C65.3193 41.112 65.9909 40.4404 66.8193 40.4404V37.4404Z",
    fill: "#686868"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3193 41.4404C65.3193 40.8881 65.7671 40.4404 66.3193 40.4404H264.319C264.872 40.4404 265.319 40.8881 265.319 41.4404V83.4404H65.3193V41.4404Z",
    fill: "#FF8818"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 63.8193,
    y1: 82.9404,
    x2: 267.819,
    y2: 82.9404,
    stroke: "#686868",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 67.8193,
    y1: 70.9404,
    x2: 262.819,
    y2: 70.9404,
    stroke: "#F9B678",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeDasharray: "12 15"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 99.8193,
    cy: 143.94,
    r: 6,
    fill: "#959595"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.819,
    cy: 143.94,
    r: 6,
    fill: "#959595"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 150.819,
    y: 176.94,
    width: 34,
    height: 5,
    rx: 2.5,
    fill: "#959595"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-1_39870_62264",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.8193,
    y: 27.9404,
    width: 18,
    height: 26,
    rx: 2
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 84.8193,
    y: 27.9404,
    width: 18,
    height: 26,
    rx: 2,
    fill: "white",
    stroke: "#686868",
    strokeWidth: 6,
    mask: "url(#path-15-inside-1_39870_62264)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-16-inside-2_39870_62264",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120.819,
    y: 27.9404,
    width: 18,
    height: 26,
    rx: 2
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 120.819,
    y: 27.9404,
    width: 18,
    height: 26,
    rx: 2,
    fill: "white",
    stroke: "#686868",
    strokeWidth: 6,
    mask: "url(#path-16-inside-2_39870_62264)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-17-inside-3_39870_62264",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.819,
    y: 27.9404,
    width: 18,
    height: 26,
    rx: 2
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 156.819,
    y: 27.9404,
    width: 18,
    height: 26,
    rx: 2,
    fill: "white",
    stroke: "#686868",
    strokeWidth: 6,
    mask: "url(#path-17-inside-3_39870_62264)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-18-inside-4_39870_62264",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 192.819,
    y: 27.9404,
    width: 18,
    height: 26,
    rx: 2
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 192.819,
    y: 27.9404,
    width: 18,
    height: 26,
    rx: 2,
    fill: "white",
    stroke: "#686868",
    strokeWidth: 6,
    mask: "url(#path-18-inside-4_39870_62264)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-19-inside-5_39870_62264",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 228.819,
    y: 27.9404,
    width: 18,
    height: 26,
    rx: 2
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 228.819,
    y: 27.9404,
    width: 18,
    height: 26,
    rx: 2,
    fill: "white",
    stroke: "#686868",
    strokeWidth: 6,
    mask: "url(#path-19-inside-5_39870_62264)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 31.6807,
    y: 15.7646,
    width: 4,
    height: 16,
    rx: 2,
    transform: "rotate(-44.9094 31.6807 15.7646)",
    fill: "#959595"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 59.6807,
    y: 0.94043,
    width: 4,
    height: 16,
    rx: 2,
    fill: "#959595"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0293,
    y: 46.3193,
    width: 4,
    height: 16,
    rx: 2,
    transform: "rotate(-95 22.0293 46.3193)",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoContent);
export default __webpack_public_path__ + "static/media/no-content.481edd4e552d7255b054cd6de609fd7e.svg";
export { ForwardRef as ReactComponent };